import React from 'react';
import BlogCard from './BlogCard';
import './BlogsGrid.css';

const BlogsGrid = ({ posts }) => {
  return (
    <div className="blogs-grid">
      {posts.map((post, index) => (
        <div key={post.id} className={`fade-up stagger-${index + 1}`}>
          <BlogCard post={post} />
        </div>
      ))}
    </div>
  );
};

export default BlogsGrid;
